export default "__VITE_ASSET__CKJilXVp__"